import { Eye } from 'lucide-react';
import { useLocation } from 'react-router';
import type { ModuleKey } from '@bill-alps/backend/features/companies/modules';
import { useCurrentUser } from '@/hooks/use-current-user';
import { useTranslation } from '../i18n/useTranslation';

const MODULE_PATHS: Array<[ModuleKey, RegExp]> = [
  ['invoicing', /^\/(quotes|bills|recurring-invoices|clients|templates)/],
  ['accounting', /^\/(expenses|financial-statements)/],
  ['payroll', /^\/(employees|payslips)/],
];

export function ReadOnlyBanner() {
  const { pathname } = useLocation();
  const { canReadModule, canWriteModule } = useCurrentUser();
  const { t } = useTranslation('common');
  const module = MODULE_PATHS.find(([, pattern]) =>
    pattern.test(pathname),
  )?.[0];
  if (!module || !canReadModule(module) || canWriteModule(module)) return null;

  return (
    <div className="mb-5 flex shrink-0 items-center gap-2 rounded-lg border-2 border-border bg-riso-amber/15 px-4 py-3 text-sm font-medium lg:group-has-[[data-split-view]]/main:mx-8 lg:group-has-[[data-split-view]]/main:mt-6">
      <Eye className="size-4" />
      {t('readOnlyAccess')}
    </div>
  );
}
